<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button [text]="'ZURUECK' | translate"></ion-back-button>
    </ion-buttons>
    <ion-title>{{ 'MITTEILUNGEN' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  @if (news(); as newsEntry) {
    <div>
      @if (newsEntry.newsImage) {
        <div class="mitteilungen-list-item-image">
          <img [src]="newsEntry.newsImage.fileSrcOptimized | prependServerToFileSrc" [alt]="'BILD' | translate">
        </div>
      }
    </div>
    <div class="padding-16">
      <div class="flex flex-column gap-4">
        <p><small>{{ newsEntry.showFrom | formatDate }}</small></p>
        <h1>{{ newsEntry.title }}</h1>
        @if (newsEntry.author; as author) {
          <work-ui-infoblock
            [avatarImgSrc]="author.userImage ? (author.userImage.fileSrcThumbnail | prependServerToFileSrc) : null"
            [label]="'VON' | translate"
            [title]="author.firstName + ' ' + author.lastName"
            [withAvatar]="true"
            [textCenteredVertically]="true"
            avatarStatus="none" />
        }
      </div>
      <div [innerHTML]="newsEntry.text" class="padding-vertical-16 work-text-prose"></div>

      @if (photos().length > 0) {
        <section class="mitteilungen-details-page-photos">
          <h2>{{ 'FOTOS' | translate }}</h2>
          <div class="mitteilungen-details-page-photos__grid">
            @for (photo of photos(); track photo.id) {
              <button (click)="openLightbox(photo)"
                      class="mitteilungen-details-page-photos__thumbnail"
                      type="button">
                <img [src]="photo.fileSrcThumbnail | prependServerToFileSrc" [alt]="photo.name ?? ''">
              </button>
            }
          </div>
        </section>
      }

      @if (attachments().length > 0) {
        <section class="mitteilungen-details-page-attachments">
          <h2>{{ 'ANHAENGE' | translate }}</h2>
          <ul class="work-list">
            @for (attachment of attachments(); track attachment.id) {
              <li>
                <a [href]="attachment.downloadUrl"
                   class="mitteilungen-details-page-attachments__item"
                   target="_blank"
                   rel="noopener">
                  <work-ui-icon name="description" />
                  <span class="work-text-overflow-ellipsis">{{ attachment.name }}</span>
                  <work-ui-icon name="download" />
                </a>
              </li>
            }
          </ul>
        </section>
      }
      @if (showConfirmationRequest()) {
        <section class="work-card work-card--warning">
          <p class="flex gap-8 flex-row vertical-center margin-bottom-8">
            <work-ui-icon name="mark_email_read" />
            <span>{{ 'LESEBESTAETIGUNG_ANGEFORDERT_HINWEIS' | translate }}</span>
          </p>
          <work-ui-button (buttonClick)="confirmRead()"
                          [(loadingState)]="confirmLoadingState"
                          [showLoadingOnClick]="true"
                          [text]="'LESEBESTAETIGUNG_ABGEBEN' | translate"
                          iconName="check" />
        </section>
      } @else if (readConfirmation()?.confirmedAt; as confirmedAt) {
        <p class="work-text-color-light flex gap-8 flex-row vertical-center">
          <work-ui-icon name="check_circle" fontColor="success" />
          <small>{{ 'LESEBESTAETIGUNG_ABGEGEBEN_AM_ZEITPUNKT' | translate: { datetime: confirmedAt | formatDate: 'DD.MM.YYYY, HH:mm' } }}</small>
        </p>
      }
    </div>

    @if (photos().length > 0) {
      <work-ui-lightbox #lightbox [images]="photos()" [readonly]="true" />
    }
  }
</ion-content>
